export default "__VITE_ASSET__dfd73782__"